import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showErrorMessage,
    DialogSize
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {NewsService} from "../../serverService/news/NewsService";
import AddNewNews from "./AddNewNews";

export default function NewsList() {

    const size = 25
    let page = 0

    const service = new NewsService()

    const [totalItems, setTotalItems] = useState("")
    const [news, setNews] = useState([]);
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);

    const navigate = useNavigate()

    useEffect(() => {
        getDataFromServer()
    }, []);


    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getNews(
            page, size
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setNews([])
            response.data.map((item, index) => {
                setNews(prev => [
                    ...prev,
                    prepareNewsItem(
                        item.id,
                        (page * size) + index + 1,
                        item.title,
                        item.postedAt,
                        item.enabled
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function prepareNewsItem(id, number, title, postedAt) {
        return {
            id,
            number,
            title,
            postedAt: convertUniversalDateTimeToPersianDateTime(postedAt)
        }
    }

    function handleSelectRow(newsId) {
        let _newsTitle = ""
        news.map((item) => {
            if (item.id === newsId)
                _newsTitle = item.title
        })

        navigate(
            RouteHelper.MagazineNewsDetail.globalUrl.replace(":id", newsId),
            {state: {title: _newsTitle}, replace: false}
        )
    }

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    function addNewNewsToTable(item) {
        const newSliders = addNewRowToTable(
            prepareNewsItem(
                item.id,
                1,
                item.title,
                item.postedAt,
                item.enabled
            ),
            news
        )


        setNews(newSliders)
        handleCloseDialog()
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن خبر جدید"}
                dialogSize={DialogSize.LARGE}
            >
                <AddNewNews handleAddNewNewsToList={addNewNewsToTable}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Magazine.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.MagazineNews.name,
                        RouteHelper.MagazineNews.url
                    )
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"خبرها"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={news}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>

        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "postedAt",
        label: "تاریخ"
    },
]
